export default __webpack_public_path__ + "static/media/american-express.827b9630.svg";